// extracted by mini-css-extract-plugin
export default {"OutgoingContainer":"Outgoing_OutgoingContainer__oO8Vl","Outgoing":"Outgoing_Outgoing__Z2AYU","top":"Outgoing_top__oa2Ns","bottom":"Outgoing_bottom__UqWak"};